function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffa000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#805000"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffc107"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ff9e18"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffd043"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ffcd87"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ff9292"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#db0032"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "bell-2",
  "data-name": "bell",
  transform: "translate(0.144)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_234",
  "data-name": "Path 234",
  d: "M208.91,0a6.312,6.312,0,0,0-6.372,6.25,6.1,6.1,0,0,0,.084.895,1.267,1.267,0,0,0,1.274,1.07,1.325,1.325,0,0,0,.359-.05,16.754,16.754,0,0,1,9.331,0,1.334,1.334,0,0,0,1.631-1.1,5.555,5.555,0,0,0,.077-.82A6.312,6.312,0,0,0,208.92,0Z",
  transform: "translate(-184.732 0)",
  fill: "#f57c00"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_235",
  "data-name": "Path 235",
  d: "M197.772,426.667H182.478a1.262,1.262,0,0,0-1.274,1.25,8.923,8.923,0,0,0,17.842,0A1.262,1.262,0,0,0,197.772,426.667Z",
  transform: "translate(-165.947 -376.667)",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_236",
  "data-name": "Path 236",
  d: "M101.443,83.4c-.4-.872-.91-1.847-1.471-2.923a40.131,40.131,0,0,1-5.72-18.85c0-9.907-5.353-17.177-13.631-18.52a16.514,16.514,0,0,0-13.412,3.835,17.4,17.4,0,0,0-6.117,13.8A39.345,39.345,0,0,1,55.4,80.508c-.548,1.06-1.048,2.025-1.445,2.885a4.9,4.9,0,0,0,2.507,6.539,5.119,5.119,0,0,0,2.1.441H96.842a4.99,4.99,0,0,0,5.052-4.925,4.861,4.861,0,0,0-.448-2.052h0Z",
  transform: "translate(-53.506 -37.873)",
  fill: "url(#linear-gradient-2)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_237",
  "data-name": "Path 237",
  d: "M104.25,122.834a1.262,1.262,0,0,1-1.274-1.25,1.23,1.23,0,0,1,.135-.56l.41-.79a45.149,45.149,0,0,0,6.252-21.15c0-6.342,3.005-13.75,11.47-13.75a1.25,1.25,0,1,1,0,2.5c-8.279,0-8.921,8.61-8.921,11.25a47.241,47.241,0,0,1-6.533,22.287l-.4.772A1.278,1.278,0,0,1,104.25,122.834Z",
  transform: "translate(-97.065 -75.334)",
  fill: "url(#linear-gradient-3)"
}));

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_104",
  "data-name": "Ellipse 104",
  cx: 11.463,
  cy: 10.27,
  rx: 11.463,
  ry: 10.27,
  transform: "translate(0 1.556)",
  fill: "url(#linear-gradient-4)"
});

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bell",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48.531,
    height: 60,
    viewBox: "0 0 48.531 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.390752e4.svg";
export { ForwardRef as ReactComponent };